import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles';
import { CompareBar } from '@bd/bdui-compare';
import withData from '@bd/bdcore-data';
import CommunityCompareCard from './CommunityCompareCard';
import HomeCompareCard from './HomeCompareCard';
import PlanCompareCard from './PlanCompareCard';
import { colors } from '../styles';

const styles = css`
  position: fixed;
  bottom: -160px;
  left: 0;
  width: 100%;
  height: 150px;
  background-color: ${colors.body};
  color: ${colors.bodyTextSmall};
  z-index: 200;
  transition: bottom 0.5s;
  color: white;
  padding: 15px;
  display: none;

  &.CompareBar-active {
    @media(min-width: 992px) {
      display: flex;
      bottom: 0;
    }
  }

  .CompareBar_items {
    display: flex;
    flex: 6;
    list-style: none;
    padding: 0;
    margin: 0;
    color: white;
    position: relative;
  }

  .CompareBar_item {
    flex: 2;
    position: relative;
    padding: 5px 10px;
    max-width: 420px;
  }

  .CompareBar_item-count {
    position: absolute;
    position: absolute;
    top: 0;
    right: 0;
    height: 120px;
    width: 360px;
    display: flex;
    align-items: center;
    font-weight: 700;
    font-size: 28px;
    color: ${colors.white};
    letter-spacing: 4px;
    text-align: center;
    background-image: linear-gradient(-80deg, #000000 0%, rgba(0,0,0,0.00) 100%);
    justify-content: flex-end;
    padding-right: 50px;
  }

  .CompareBar_buttonList {
    width: 240px;
    margin-left: auto;
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: center;

    .CompareBar_buttonListItem {
      width: 150px;
      height: 36px;
      box-shadow: 0 15px 20px 0 rgba(0,0,0,0.20);
      & + li {
        .CompareBar_button {
          background-color: ${colors.bodyLightest};
          margin-top: 10px;
          cursor: pointer;
          color: ${colors.bodyLightestTextSmall};
          &:hover {
            background-color: ${colors.bodyLightest};
          }
        }
      }
    }
  }
  .CompareBar_button {
    border-radius: 5px;
    width: 100%;
    height: 100%;
    background-color: ${colors.brand3};
    font-weight: 700;
    font-size: 14px;
    color: ${colors.brand3TextLarge};
    letter-spacing: 2px;
    text-align: center;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all .3s ease-out;
    &:hover {
      background-color: ${colors.brand3Dark};
    }
  }

  .CompareBar_itemToggle {
    position: absolute;
    top: 8px;
    right: 15px;
    border: 1px solid ${colors.bodyDarkerTextSmall};
    border-radius: 5px;
    width: 22px;
    height: 22px;
    cursor: pointer;

    &:before {
      content: "\\2715";
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 5px;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border: 1px solid ${colors.bodyDarker};
      color: ${colors.bodyDarkerTextSmall};
    }
  }
`;

function StyledCompareBar(props) {
  if (!get(props.builder, 'products.BDWebsiteCompare.isPurchased')) {
    return null;
  }
  return (
    <CompareBar
      className={styles}
      {...props}
      renderItem={(type, item) => {
        if (type === 'homes') {
          return <HomeCompareCard home={item} />;
        } else if (type === 'communities') {
          return <CommunityCompareCard community={item} />;
        } else if (type === 'plans') {
          return <PlanCompareCard plan={item} />;
        }

        return null;
      }}
      displayLimit={3}
      compareLinkText="Compare"
      compareLinkRoute="compare"
    />
  );
}

StyledCompareBar.propTypes = {
  builder: PropTypes.object.isRequired,
};

export default withData({ builder: true })(StyledCompareBar);



// WEBPACK FOOTER //
// ./src/components/CompareBar.js